import { DELETE_API, GET_API, POST_API, PUT_API } from "../../Functionalities/APIs";

export const ManageSloats = async (e, keyword, data, params) => {
    let function_name = "Variants";
    let path = "/items/sloat/";

    if (keyword == "add") {
        var fdata = new FormData();

        fdata.append("name", data.label || data.name || "");
        fdata.append("from_time", data.from_time)
        fdata.append("to_time", data.to_time)
        fdata.append("is_time_depended", data.time_dependant == true ? 1 : 0)

        let result = POST_API(fdata, "", path);

        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "update") {
        var fdata = new FormData();
        fdata.append("id", data.id);
        fdata.append("name", data.label || data.name || "");
        fdata.append("from_time", data.from_time)
        fdata.append("to_time", data.to_time)
        fdata.append("is_time_depended", data.time_dependant == true ? 1 : 0)
        fdata.append("is_active", data.is_active === true ? 1 : 0)

        let result = PUT_API(fdata, "", path);

        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "delete") {
        let result = DELETE_API("", params, path);

        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "get") {
        let result = GET_API("", params, path);

        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
};